import React, { FC } from 'react'

export const AvatarGroup: FC = (props) => (
  <div {...props} style={{ display: 'flex' }} />
)
